import { MemfsJson } from '../../../state/files-store';
import { linkFile } from './link-file';
import { reactRenderFile } from './react-render-file';
import { CapsuleType } from '@bit/amit.capsule-dev.remote-capsule';

// TODO
const mainFolder = '/capsule/src/App/';
export const mainFilePath = mainFolder + 'index.js';
const linkFilePath = mainFolder + 'story-link.js';

export function makeFsJson(capsuleType: CapsuleType | undefined, importSource: string) {
	if (!importSource) return undefined;
	if (!capsuleType) return undefined;

	const files: MemfsJson = {
		[mainFilePath]: getRenderer(capsuleType)(),
		[linkFilePath]: linkFile(importSource),
	};

	return files;
}

function getRenderer(capsuleType?: CapsuleType) {
	switch (capsuleType) {
		case CapsuleType.react:
			return reactRenderFile;
		case CapsuleType.angular:
		case CapsuleType.node:
		case CapsuleType.vue:
		default:
			return () => '';
	}
}

// function makeFiles(importSource: string) {
// 	if (!importSource) return undefined;

// 	const files: MemfsJson = {
// 		[absMainFile]: generateLinkFile(),
// 		[linkFile]: generateLink(`${importSource}/dist/examples`),
// 	};

// 	return files;
// }
